module.exports = __webpack_public_path__ + "img/page_img2.f55596cc.jpg";